var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgImageIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image-camera-1--photos-picture-camera-photography-photo-pictures"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.1431 8.57145C23.1431 8.11679 22.9625 7.68075 22.641 7.35926C22.3195 7.03777 21.8835 6.85716 21.4289 6.85716H18.0003L15.4289 3.42859H8.57171L6.00028 6.85716H2.57171C2.11705 6.85716 1.68102 7.03777 1.35952 7.35926C1.03803 7.68075 0.857422 8.11679 0.857422 8.57145V18.8572C0.857422 19.3118 1.03803 19.7479 1.35952 20.0693C1.68102 20.3908 2.11705 20.5714 2.57171 20.5714H21.4289C21.8835 20.5714 22.3195 20.3908 22.641 20.0693C22.9625 19.7479 23.1431 19.3118 23.1431 18.8572V8.57145Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0007 16.7143C14.1309 16.7143 15.8578 14.9874 15.8578 12.8571C15.8578 10.7269 14.1309 9 12.0007 9C9.87046 9 8.14355 10.7269 8.14355 12.8571C8.14355 14.9874 9.87046 16.7143 12.0007 16.7143Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImageIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/image_icon.e49d4f3d56f6bc10970187debdb9a0d0.svg";